<template>
  <b-modal
    :id="`modal-new-rule-keyword-edit-${ruleIndex}`"
    title="Edição de Regra de palavra chave"
    size="xl"
  >
    <div class="overflow">
      <label>Nome da regra</label>
      <b-form-input
        v-model="newRuleName"
        placeholder="Nome da regra"
      ></b-form-input>

      <div v-for="(item, index) in listRules" :key="index">
        <div>
          <div class="rule-container mt-4">
            <div style="width: 60px">Regra {{ index + 1 }}</div>
            <div class="line"></div>
          </div>

          <div class="mt-4">
            <label>Receberão alertas (por palavra)</label>
            <p>
              Digite o e-mail do usuário que receberá o alerta e adicione as
              palavras chave, para adicionar as palavras clique em +
            </p>

            <label>E-mail</label>
            <div class="input">
              <b-form-input
                class="mb-2"
                placeholder="Entre com o email"
                v-model="newEmail"
                type="email"
              ></b-form-input>
              <button
                class="btn btn-add ml-1"
                @click="addEmail(index, newEmail)"
              >
                <font-awesome-icon :icon="['fas', 'plus']" />
              </button>
            </div>

            <div class="row">
              <div
                v-for="(email, indexEmail) in item.emails"
                :key="indexEmail"
                class="col-6 container-tag"
              >
                <div class="tag-email">
                  {{ email }}
                  <div @click="removeItem('email', index, indexEmail)">X</div>
                </div>
              </div>
            </div>
          </div>

          <div>
            <label>Palavras chave</label>
            <div class="input">
              <b-form-input
                class="mb-2"
                placeholder="Entre com a palavra chave"
                v-model="newKeyword"
              ></b-form-input>
              <button
                class="btn btn-add ml-1"
                @click="addKeyword(index, newKeyword)"
              >
                <font-awesome-icon :icon="['fas', 'plus']" />
              </button>
            </div>

            <div class="row">
              <div
                v-for="(keyword, indexKeyword) in item.keywords"
                :key="indexKeyword"
                class="col-3 container-tag"
              >
                <div class="tag-keyword">
                  {{ keyword }}
                  <div @click="removeItem('keyword', index, indexKeyword)">
                    X
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <button class="add-alert" @click="addNewRule">
          <font-awesome-icon :icon="['fas', 'plus']" /> Adicionar mais alertas
          por palavras
        </button>
      </div>
    </div>

    <template v-slot:modal-footer>
      <div>
        <button class="btn btn-secondary" @click="hideModal">
          {{ $t('newAction.stepOne.cancelButton') }}
        </button>
        <button class="btn btn-primary" @click="updateRule()">
          {{ $t('newAction.stepOne.saveButton') }}
        </button>
      </div>
    </template>
  </b-modal>
</template>

<script>
import { mapState } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import NewAlertRule from '@/components/organisms/settings/settings-alert-rules/new-rule';
import EventBus from '../../../eventBus';
import api from '../../../services/api';

export default {
  components: {
    NewAlertRule,
  },

  computed: {
    ...mapFields('actions', ['action']),
  },

  props: ['actionId', 'rule', 'ruleIndex'],

  data: () => ({
    userAuth: null,
    listRules: [
      {
        emails: [],
        keywords: [],
      },
    ],
    newEmail: null,
    newKeyword: null,
    newRuleName: null,
    ruleId: null
  }),

  methods: {
    async updateRule() {
      this.listRules.name = this.newRuleName;

      await api.patch(
        `/keywords-alert/${this.ruleId}`,
        {
          listRulesKeywords: this.listRules,
          name: this.listRules.name,
        },
        {
          headers: {
            'x-access-token': this.userAuth.token,
          },
        },
      );

      EventBus.$emit('update-table-rule-keyword', {
        listRulesKeywords: this.listRules,
      });

      this.hideModal();
    },

    addNewRule() {
      this.listRules.push({
        emails: [],
        keywords: [],
      });
    },

    removeItem(type, indexRule, indexItem) {
      if (type === 'keyword') {
        this.listRules[indexRule].keywords.splice(indexItem, 1);
      } else {
        this.listRules[indexRule].emails.splice(indexItem, 1);
      }
    },

    hideModal() {
      this.$bvModal.hide(`modal-new-rule-keyword-edit-${this.ruleIndex}`);
      this.listRules = [
        {
          emails: [],
          keywords: [],
        },
      ];
    },

    addEmail(index, newEmail) {
      this.listRules[index].emails.push(newEmail);
      this.newEmail = null;
    },

    addKeyword(index, newKeyword) {
      this.listRules[index].keywords.push(newKeyword);
      this.newKeyword = null;
    },
  },
  mounted() {
    this.userAuth = JSON.parse(localStorage.getItem('_indecx'));

    EventBus.$on('get-data-rule', async (idRule) => {
       this.ruleId = idRule;

       const response = await api.get(
          `keywords-alert/${this.userAuth.companyId}/${idRule}`,
          {
            headers: { 'x-access-token': this.userAuth.token },
            params: {
              id: idRule
            },
          },
        );

        this.listRules = response.data.listRulesKeywords;
        this.newRuleName = response.data.name;
    });
  },

  created() {
  },
};
</script>

<style lang="scss" scoped>
@import '@/themes/default/variables.scss';
.overflow {
  height: 500px;
  overflow: auto;
  padding: 0 24px 0px 12px;
}

.rule-container {
  font-weight: 700;
  line-height: 20px;
  display: flex;
  align-items: center;
  color: #bababa;
}

label {
  font-weight: 500;
  line-height: 24px;
}

.line {
  width: 92%;
  height: 1px;
  background: rgba(0, 0, 0, 0.25);
}

.input {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  flex: 1 0 0;
}

.btn-add {
  color: $primary;
  border: 1px solid $primary;
  &:hover {
    color: $white;
    background-color: $primary;
  }
}

.add-alert {
  color: #527bf2;
  background: #fff;
  border: none;
}

.container-tag {
  margin-bottom: 12px;
}

.tag-email {
  background: #37c888;
  color: #fff;
  width: 100%;
  padding: 2px 12px;
  border-radius: 4px;
  justify-content: space-between;
  display: flex;
}

.tag-keyword {
  background: #5299f2;
  color: #fff;
  width: 100%;
  padding: 2px 12px;
  border-radius: 4px;
  justify-content: space-between;
  display: flex;
}
</style>



// WEBPACK FOOTER //
// src/components/molecules/modal-new-rule-keyword-edit/index.vue